import { AlertCircle } from "lucide-react";
import type { ElementType, ReactNode } from "react";
import HubertLogo from "../../assets/images/hubert-logo.png";

interface CommonErrorPageProps {
    title: string;
    description: string;
    Icon?: ElementType;
}
type ErrorPageWithoutChildren = CommonErrorPageProps & {
    children?: never;
    hideNextSteps: false;
};

type ErrorPageWithChildren = CommonErrorPageProps & {
    hideNextSteps: true;
    children: ReactNode;
};

type ErrorPageProps = ErrorPageWithoutChildren | ErrorPageWithChildren;

const ErrorPage = ({ title, description, hideNextSteps, Icon = AlertCircle, children }: ErrorPageProps) => {
    return (
        <div className="max-h-screen overflow-hidden p-6 md:p-0">
            <div className="mx-auto -mt-24 flex h-[100dvh] max-w-[65ch] flex-col justify-center gap-4 overflow-hidden">
                <div className="flex flex-col items-start justify-start gap-2 text-start md:gap-4">
                    {Icon && <Icon className="h-12 w-12" />}
                    <h1 className="text-4xl md:text-5xl">{title}</h1>
                    <p>{description}</p>
                </div>
                <div>
                    <p>If you think we got it wrong, try and:</p>
                    {!hideNextSteps ? (
                        <ul className="list-disc pl-8">
                            <li>Enable cookies if you have them blocked</li>
                            <li>
                                <span
                                    onClick={() => window.location.reload()}
                                    className="text-violet cursor-pointer underline"
                                >
                                    Reload the page
                                </span>{" "}
                                and see if that fixes it
                            </li>
                            <li>
                                Go back to the{" "}
                                <a href={`${window.location.origin}/`} className="text-violet underline">
                                    home page
                                </a>
                                .
                            </li>
                        </ul>
                    ) : (
                        children
                    )}
                </div>
            </div>
            <img
                className="absolute right-1/2 bottom-0 left-1/2 w-32 -translate-x-1/2 -translate-y-1/2"
                src={HubertLogo}
                alt="Hubert Logo"
            />
        </div>
    );
};

export default ErrorPage;
